import { AnyAction, CombinedState, combineReducers } from '@reduxjs/toolkit';
import notificationsReducer from './notificationsSlice';
import settingsReducer from './settingsSlice';
import applicationsReducer from 'handlers/applicationsSlice';
import borrowersReducer from 'handlers/borrowersSlice';
import documentsReducer from 'handlers/documentsSlice';
import snacksReducer from 'handlers/snacksSlice';
import borrowerProfileGroupsReducer from 'handlers/borrowerProfileGroupsSlice';
import borrowerProfileCardsReducer from 'handlers/borrowerProfileCardsSlice';
import BorrowerProfileVariableConfigurationsReducer from 'handlers/borrowerProfileVariableConfigurationsSlice';
import activeBorrowerInformationReducer from 'handlers/activeBorrowerInformationSlice';
import variablesReducer from './variablesSlice';
import layoutConfigurationsReducer from './layoutConfigurationsSlice';
import tasksReducer from './tasksSlice';
import applicationDataReducer from './applicationDataSlice';
import portalPageGroupsReducer from './portalPageGroupsSlice';
import portalPageCardsReducer from './portalPageCardsSlice';
import portalPageVariableConfigurationsReducer from './portalPageVariableConfigurationsSlice';
import globalLoadingReducer from './globalLoadingSlice';
import { IReduxState } from 'types/ReduxState';
import { apiSlice } from 'slices';

const appReducer = combineReducers<IReduxState>({
  notifications: notificationsReducer,
  settings: settingsReducer,
  applications: applicationsReducer,
  borrowers: borrowersReducer,
  applicationDocuments: documentsReducer,
  snacks: snacksReducer,
  borrowerProfileGroups: borrowerProfileGroupsReducer,
  borrowerProfileCards: borrowerProfileCardsReducer,
  borrowerProfileVariableConfigurations: BorrowerProfileVariableConfigurationsReducer,
  variables: variablesReducer,
  layoutConfigurations: layoutConfigurationsReducer,
  activeBorrowerInformation: activeBorrowerInformationReducer,
  tasks: tasksReducer,
  applicationData: applicationDataReducer,
  portalPageGroups: portalPageGroupsReducer,
  portalPageCards: portalPageCardsReducer,
  portalPageVariableConfigurations: portalPageVariableConfigurationsReducer,
  globalLoading: globalLoadingReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const rootReducer = (state: IReduxState | undefined, action: AnyAction): CombinedState<IReduxState> => {
  if (!state) {
    return appReducer(state, action);
  }

  let nextState: Partial<IReduxState> = state;

  if (action.type === 'auth/logout/fulfilled' || action.type === 'auth/logout/rejected') {
    nextState = {
      settings: state.settings,
      notifications: state.notifications,
      globalLoading: state.globalLoading,
      [apiSlice.reducerPath]: state[apiSlice.reducerPath],
    };
  }

  return appReducer(nextState as IReduxState, action);
};

export default rootReducer;
